module.exports = __webpack_public_path__ + "static/media/wmsui32_1306.25ef4116.ico";